import { FC } from "react";

import { MinusIcon, PlusIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import MapMenuItemControl from "../menuItemControl";

type Props = {
  zoomLevel: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  className?: string;
};

const MapZoomControl: FC<Props> = ({
  zoomLevel,
  onZoomIn,
  onZoomOut,
  className
}) => (
  <div
    className={twMerge(
      "my-2 overflow-hidden rounded-lg border-[1px] border-gainsboro",
      className
    )}
  >
    <MapMenuItemControl onClick={onZoomIn} aria-label="Zoom in">
      <PlusIcon className="fill-dim-gray" />
    </MapMenuItemControl>
    <MapMenuItemControl>
      <span className="select-none text-sm font-700 text-txtBody">
        {Math.floor(zoomLevel)}
      </span>
    </MapMenuItemControl>
    <MapMenuItemControl onClick={onZoomOut} aria-label="Zoom out">
      <MinusIcon className="fill-dim-gray" />
    </MapMenuItemControl>
  </div>
);

export default MapZoomControl;
